import React, { useState } from 'react';
import styles from '../styles/ConnectWorkplace.module.scss';
import { CheckCircle } from 'components/icons';
import { Select } from 'components/form-fields-v2';
import { Back } from 'components/quashed';
import Button from 'components/button';
import { Input, Checkbox } from 'semantic-ui-react';
import { formatInquiryMessage } from '../utils';
import { createAdviserInquiry } from 'services';

const ConnectWorkplacePage = ({ values, onBack, onSubmit }) => {
  const { otherEmployerName } = values;

  const [error, setError] = useState(false);
  const [formValues, setFormValues] = useState({
    haveBenefits: '',
    hrName: '',
    hrEmail: '',
    anonymous: false,
    workplace: otherEmployerName,
  });

  const handleSubmit = async () => {
    if (!formValues.haveBenefits) {
      setError(true);
    } else {
      const message = formatInquiryMessage(formValues);
      try {
        await createAdviserInquiry({ message });
      } catch (e) {
        // don't do anything still let user add workplace
      }
      onSubmit();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (name === 'haveBenefits' && error) {
      setError(false);
    }
  };

  const handleCheckboxChange = () => {
    setFormValues({ ...formValues, anonymous: !formValues.anonymous });
  };

  return (
    <div className={styles.container}>
      <div className={styles.workplaceName}>
        <CheckCircle />
        {otherEmployerName}
      </div>
      <div className={styles.title}>
        You can help your workplace skip the line and bring the benefits of
        Quashed to your workmates quicker by answering the questions below:
      </div>
      <div className={styles.form}>
        <Select
          basic={true}
          className={classnames(styles.dropdown, error && styles.error)}
          inputClassName={classnames(
            styles.dropdownInput,
            error && styles.error,
          )}
          key="haveBenefits"
          label="Does your workplace currently provide any insurance benefits?"
          options={[
            { key: 'yes', value: 'yes', text: 'Yes' },
            { key: 'no', value: 'no', text: 'No' },
            { key: 'idk', value: 'idk', text: "I don't know" },
          ]}
          placeholder="Select one"
          name="haveBenefits"
          value={formValues.haveBenefits}
          onChange={handleInputChange}
        />

        <label className={styles.contactLabel}>
          Your workplace's HR contact information (optional)
        </label>
        <div className={styles.textInputWrapper}>
          <Input
            className={styles.textInput}
            key="contactName"
            name="hrName"
            placeholder="Enter name"
            value={formValues.hrName}
            onChange={handleInputChange}
          />
          <Input
            className={styles.textInput}
            key="contactEmail"
            name="hrEmail"
            placeholder="Enter email"
            value={formValues.hrEmail}
            onChange={handleInputChange}
          />
        </div>
        <Checkbox
          className={styles.checkBox}
          key="anonymous"
          checked={formValues.anonymous}
          onChange={handleCheckboxChange}
          label="I would like to stay anonymous"
        />
      </div>
      <div className={styles.buttons}>
        <Back onClick={onBack} className={styles.back} text="Previous" />
        <Button
          onClick={handleSubmit}
          className={styles.submitBtn}
          text="Submit"
        />
      </div>
    </div>
  );
};

export default ConnectWorkplacePage;
